if (document.querySelector('.js-tagsFilters')) {
  let arrTags = [];
  const tags = document.querySelectorAll('.js-tagsFilters .tag');
  const moreBtn = document.querySelector('.js-moreTags');

  if (document.documentElement.clientWidth < 1024) {
    if (tags.length > 5) {
      moreBtn.style.display = 'block'
    }
  } else if (document.documentElement.clientWidth >= 1024) {
    if (tags.length > 11) {
      moreBtn.style.display = 'block'
    }
  }

  const hideTags = () => {
    for (let i = 0; i <= (tags.length - 1); i++) {
      if (document.documentElement.clientWidth < 1024) {
        if (i > 4) {
          tags[i].style.display = 'none';
        }
      } else if (document.documentElement.clientWidth >= 1024) {
        if (i > 10) {
          tags[i].style.display = 'none';
        }
      }
    }
  }

  hideTags();

  document.querySelectorAll('.js-tagsFilters .tag input').forEach(elem => {
    elem.addEventListener('change', (event) => {
      event.target.closest('.tags-filter__form').submit()
    })
  })

  moreBtn.addEventListener('click', event => {
    const eventTar = event.target;

    if (event.target.classList.contains('is-open')) {
      hideTags();
      eventTar.textContent = 'Показать ещё'
      eventTar.classList.remove('is-open');
    } else {      
      tags.forEach(elem => {
        elem.style.display = null;
      })
      eventTar.textContent = 'Скрыть'
      eventTar.classList.add('is-open');
    }
  })
}